import { useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LogOut } from "lucide-react";
import Button from "../Button/Button";
import LogoutButton from "../Button/LogoutButton";

const LogoutConfirmModal = ({ onCancel, onLogout }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onCancel();
      }
    };
    const handleKey = (event) => {
      if (event.key === "Escape") onCancel();
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, [onCancel]);

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/40 p-4">
        <motion.div
          ref={modalRef}
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.98 }}
          transition={{ duration: 0.08, ease: "easeOut" }}
          className="w-full max-w-sm overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-pop"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-start gap-3 px-5 pb-5 pt-5">
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-danger-50 text-danger-600">
              <LogOut size={17} strokeWidth={2} />
            </span>
            <div className="min-w-0 flex-1">
              <h2 className="text-sm font-semibold tracking-tight text-gray-900">Log out</h2>
              <p className="mt-1 text-[13px] leading-relaxed text-gray-500">
                You will need to sign in again to get back into your account.
              </p>
            </div>
          </div>

          <div className="flex justify-end gap-2 border-t border-gray-100 bg-gray-50/70 px-5 py-3">
            <Button type="button" variant="secondary" size="sm" onClick={onCancel}>
              Cancel
            </Button>
            <LogoutButton onLogout={onLogout} />
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default LogoutConfirmModal;
